import React from "react";
import PropTypes from "prop-types";

import { ReduxControls, Icon } from "rhombus-react";

import { SOCIAL_AD_TYPE_LIST } from "utils/constants";

import "./SocialAdTypeSelectionCard.css";

function OptionsMenu(props) {
	const {
		isAllSelected,
		isAllDisabled,
		handleSelectAll,
		options,
		onSelect,
	} = props;
	return (
		<>
			<ReduxControls.Checkbox
				label={"Select All"}
				className="select-all custom-checkbox"
				checked={isAllSelected}
				disabled={isAllDisabled}
				onChange={handleSelectAll}
			/>
			{options.map(option => (
				<ReduxControls.Checkbox
					key={option.value}
					label={option.label}
					className={`custom-checkbox ${option.className}`}
					checked={option.isSelected}
					disabled={option.disabled}
					onChange={(e) => {
						const { checked } = e.currentTarget;
						onSelect([option.value], checked);
					}}
				/>
			))}
		</>
	);
}

export default function SocialAdTypeSelectionCard(props) {
	const {
		platform,
		icon,
		options,
		onSelect,
	} = props;

	const availableOptions = options.filter(option => !option.disabled);
	const isAllSelected = availableOptions.every(option => option.isSelected);
	const isAllDisabled = availableOptions.length === 0;

	let $icon;

	if (typeof icon === "string") {
		$icon = (
			<Icon name={icon} />
		);
	} else if (Array.isArray(icon)) {
		$icon = icon.map(name => (
			<Icon key={name} name={name} />
		));
	} else {
		$icon = icon;
	}

	function handleSelectAll() {
		onSelect(availableOptions.map(({ value }) => value), !isAllSelected);
	}

	return (
		<div className="social-adtype-selection-card">
			<div className="header">
				<div>{$icon}</div>
				<div className="platform">{platform}</div>
			</div>
			<div className="options">
				<OptionsMenu
					{...{
						isAllSelected,
						isAllDisabled,
						handleSelectAll,
						options,
						onSelect,
					}}
				/>
			</div>
		</div>
	);
}

SocialAdTypeSelectionCard.propTypes = {
	platform: PropTypes.string.isRequired,
	icon: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.string),
		PropTypes.node
	]),
	options: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			value: PropTypes.oneOf(SOCIAL_AD_TYPE_LIST).isRequired,
			isSelected: PropTypes.bool,
			disabled: PropTypes.bool,
			className: PropTypes.string,
		})
	),
	onSelect: PropTypes.func.isRequired,
};
